
/**
 * maintenanceMessage
 * @param {Object} data, content data
 * @return {Object} normalized data
 */

import { parseDate } from "@/utils/date"
import { icons } from "@/utils/mappers"

export default (data) => {
    if (!data) {
        return null
    }
    return {
        title: data.title || '',
        date: data.date ? parseDate(data.date) : '',
        dateISOString: data.date || '',
        resolved: data.resolved || false,
        icon: icons['info-grey'],
        description: data.description || 'No description provided'
    }
}
